module.exports = __webpack_public_path__ + "img/vendas.888ee211.svg";